<template>
  <div class="order_detail">
    <nav-bar/>
    <search-bar/>
    <div class="main fz14" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/me/finance' }">财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 普通订单 -->
      <div class="product-box" v-if="type != 'service'">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order_list_item">产品信息</div>
            <div class="center order_list_item">产品规格</div>
            <div class="center order_list_item">设备信息</div>
            <div class="center order_list_item">配套工艺</div>
            <div class="center order_list_item">产品价格</div>
            <div class="center order_list_item">数量</div>
            <div class="center order_list_item">小计</div>
          </div>
          <el-divider/>
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{ order_detail.create_time }}</span>
                <span class="ml20 grey">订单编号：{{ order_detail.order_no }}</span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <div
                      class="fr jc ac order_left"
                      v-for="(goods,i) in order_detail.orderGoodsBeans"
                      :key="i"
                  >
                    <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                      <el-image class="goods_img fs mr10" :src="goods.goods_img" alt/>
                      <p class>{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
                    </div>

                    <div class="center order_list_item">{{ specNameInit(goods) }}</div>
                    <div class="center order_list_item">{{ goods.device_id ? goods.device_id : '-' }}</div>

                    <div class="center cursor order_list_item bule">
                      {{
                        goods.goods_type == 1 ?
                            "￥" + goods.goods_craft_price : '-'
                      }}
                    </div>
                    <div class="center order_list_item">￥{{ goods.goods_price }}</div>
                    <div class="center order_list_item">{{ goods.goods_num }}</div>
                    <div class="center order_list_item red">￥{{ goods.goods_total_price }}</div>
                  </div>
                </div>
              </div>

              <!--                下-->
              <div class="p20 fz14 bottom" style="text-align: right">
                <div>
                  <span>订单金额</span>
                  <span class="blue">￥{{ order_detail.order_actual_price }}</span>
                </div>
                <div class="mt10">
                  <span>已付款</span>
                  <span>￥{{ order_detail.pay_price }}</span>
                </div>
                <div class="mt10">
                  <span>未付款</span>
                  <span class="red">￥{{ sub(order_detail.order_actual_price, order_detail.pay_price) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务订单 -->
      <div class="service_box" v-if="type == 'service'">

        <span class="before-title">服务信息</span>
        <el-table :data="[order_detail]" style="width: 100%" border class="mt20">
          <el-table-column prop="order_no" label="订单编号" align="center"></el-table-column>
          <el-table-column prop="type_name" label="服务类型" align="center"></el-table-column>
          <el-table-column prop="level_name" label="服务人员" align="center"></el-table-column>
          <el-table-column label="服务时间" align="center">
            <template slot-scope="scope">
            <span>{{
                formatDate(scope.row.service_start_time, 'yyyy-MM-dd')
              }}~{{ formatDate(scope.row.service_end_time, 'yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_distance" label="距离（km）" align="center"></el-table-column>
          <el-table-column
              prop="order_actual_price"
              label="价格"
              align="center"
              v-if="order_detail.platform_sale_check_state == '1'"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 付款 -->
      <div class="bg_white pl20 pt20 pb20 pr20">
        <el-divider/>
        <p class="mb20">请选择付款方式</p>
        <div class="way fr ac" v-if="hasPermission([860,864])">
          <el-radio v-model="radio" label="1">&nbsp;</el-radio>
          <img src="/static/imgs/me/WeChat.png" alt/>
          <span>微信支付</span>
        </div>
        <div class="way fr ac" v-if="hasPermission([861,863])">
          <el-radio v-model="radio" label="2">&nbsp;</el-radio>
          <img src="/static/imgs/me/Bankcard.png" alt/>
          <span>银行卡支付</span>
          <span class="fz12 grey ml10 fr">注：网银转账后请保留转账完成页面，并截图上传。</span>
        </div>
        <div class="fr ac mt20 mb20">
          <p class="mr10 pay_title">付款金额:</p>
          <el-input
              size="mini"
              v-model="price"
              class="ml20"
              style="width:20%"
              :disabled="type === 'service'"
          ></el-input>
        </div>
        <div class="fr ac mt20" v-if="type !== 'service'">
          <p class="mr10 pay_title"></p>
          <p class="blue ml20">本次应付￥{{ actual_price }}</p>
        </div>
        <div class="fr ac mb20" v-show="radio === '2'">
          <p class="mr10 pay_title">付款凭证:</p>
          <up-load :file_list.sync="contract_imgs" :limit="6"/>
        </div>
        <div class="fr ac jc mt20 mb20" v-if="hasPermission([861,863,860,864])">
          <el-button type="primary" @click="submit">确认付款</el-button>
        </div>
      </div>
    </div>
    <footer-bar/>
    <re-dialog title="微信支付" :visible.sync="is_show">
      <div class="pay-img-box">
        <div class="fr ac jc">
          <img
              :src="'https://api.beltdance.com/qrcode/create?content='+pay_img+'&width=250&height=250'"
              class="wechat-pay-img"
              alt
          />
        </div>
        <div class="fr ac jc two">
          <div class="precautions">
            <p class="bold mb20 black">注意事项</p>
            <p>1、此码为订单收款码，请专码专用。</p>
            <p>2、分享收款码时请确认分享对象，若因分享错误造成的损失，本平台概不负责。</p>
            <p>3、此码为动态生成，有时间限制，请在生成二维码后尽快完成支付！</p>
          </div>
        </div>
      </div>
      <div slot="footer" class="fr ac jc">
        <el-button @click="is_show = false;" type="primary" size="small">确定</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";

let timer = null;
export default {
  props: {},
  data() {
    return {
      price: "",
      actual_price: "",
      order_detail: {},
      loading: false,
      type: this.$route.query.type,
      contract_imgs: [],
      radio: "1",
      is_show: false,
      pay_img: "",
    };
  },
  computed: {
    goods_price() {
      let total = 0;
      if (!this.loading) return total;
      this.order_detail.orderGoodsBeans.forEach((el) => {
        total = this.add(total, el.goods_total_price);
      });
      return total;
    },
    craft_price() {
      let total = 0;
      if (!this.loading) return total;
      this.order_detail.orderGoodsBeans.forEach((el) => {
        total = this.add(total, el.goods_craft_price);
      });
      return total;
    },
    // 计算需要支付的价格
    getprice() {
      if (this.order_detail.pay_state == 0) {
        return this.sub(
            this.order_detail.pay_start_price,
            this.order_detail.pay_price
        );
      } else if (this.order_detail.pay_state == 1) {
        let total = 0;
        if (
            Number(this.order_detail.pay_start_price) <
            Number(this.order_detail.pay_price)
        ) {
          total = this.sub(
              this.order_detail.pay_price,
              this.order_detail.pay_start_price
          );
          return this.sub(this.order_detail.pay_ing_price, total);
        } else if (
            Number(this.order_detail.pay_start_price) ==
            Number(this.order_detail.pay_price)
        ) {
          return this.order_detail.pay_ing_price;
        }
      } else if (this.order_detail.pay_state == 2) {
        let total = 0;
        if (
            this.add(
                this.order_detail.pay_start_price,
                this.order_detail.pay_ing_price
            ) < Number(this.order_detail.pay_price)
        ) {
          total = this.sub(
              this.order_detail.pay_price,
              this.add(
                  this.order_detail.pay_start_price,
                  this.order_detail.pay_ing_price
              )
          );
          return this.sub(this.order_detail.pay_end_price, total);
        } else if (
            this.add(
                this.order_detail.pay_start_price,
                this.order_detail.pay_ing_price
            ) == Number(this.order_detail.pay_price)
        ) {
          return this.order_detail.pay_end_price;
        }
      }
    },
  },
  created() {
    if (this.type === "service") {
      this.getServiceOrderDetail();
    } else {
      this.getOrderDetail();
    }
  },
  mounted() {
  },
  watch: {
    is_show(n) {
      if (!n) {
        clearTimeout(timer);
      }
    },
  },
  methods: {
    submit() {
      if (this.radio == "2") {
        if (!this.contract_imgs.length) {
          this.$message({
            type: "warning",
            message: "未上传支付凭证",
          });
          return;
        }
        // 银行卡支付
        if (this.type == "service") {
          this.insertServicePay();
        } else {
          this.insertOrderPay();
        }
      } else {
        // 微信支付
        this.wxPay();
      }
    },
    wxPay() {
      this.post("orderInterfaces/v1.0/insertOrderWxPcPay", {
        order_id: this.order_detail.order_id,
        order_actual_price: this.price,
      }).then((res) => {
        this.pay_img = res.data;
        this.is_show = true;
        // this.payStateChange();
      });
    },
    // 客户上传支付凭证-订单
    insertOrderPay() {
      this.post("orderInterfaces/v1.0/insertOrderPay", {
        order_id: this.order_detail.order_id,
        pay_charge: this.contract_imgs.join(","),
        order_actual_price: this.price,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "支付凭证已上传，请等待审核",
        });
        this.getOrderDetail();
      });
    },
    // 客户上传支付凭证-服务订单
    insertServicePay() {
      this.post("serviceInterfaces/v1.0/insertServicePay", {
        order_id: this.order_detail.order_id,
        pay_charge: this.contract_imgs.join(","),
        order_actual_price: this.price,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "支付凭证已上传，请等待审核",
        });
        this.getServiceOrderDetail();
      });
    },
    getData() {
      return this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.id,
      });
    },
    async payStateChange() {
      let data = await this.getData(); // 模拟请求
      if (this.order_detail.pay_price != data.data.pay_price) {
        clearTimeout(timer);
        this.$message({
          type: "success",
          message: "支付成功!",
        });
        setTimeout(() => {
          this.back();
        }, 1500);
      } else {
        timer = setTimeout(this.payStateChange, 2000);
      }
    },
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.id,
      }).then((res) => {
        if (res.data.pay_state == "0") {
          this.price = res.data.pay_start_price;
        } else if (res.data.pay_state == "1") {
          this.price = res.data.pay_ing_price;
        } else if (res.data.pay_state == "2") {
          this.price = res.pay_end_price;
        }
        this.order_detail = res.data;
        this.price = this.getprice;
        this.actual_price = this.getprice;

        this.loading = true;
      });
    },
    getServiceOrderDetail() {
      this.post("serviceInterfaces/v1.0/getServiceOrderDetail", {
        order_id: this.$route.query.id,
      }).then((res) => {
        this.price = res.data.order_actual_price;
        this.order_detail = res.data;
        this.loading = true;
      });
    },
  },
  components: {NavBar, SearchBar, FooterBar, "up-load": Upload},
};
</script>

<style scoped lang="scss">
.order_detail {
  font-size: 14px;

  .pay-img-box {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 50%);
    grid-template-rows: 380px;

    .two {
      margin-top: 10%;
      height: 80%;
      border-left: 1px solid #b7b7b7;
    }

    .precautions {
      width: 340px;
      line-height: 24px;
      color: #999999;
    }
  }

  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .product-box {
      background-color: #fff;
      padding: 20px;

      .info {
        background-color: #fff;

        .order_list_item {
          &:nth-of-type(1) {
            width: 400px;
          }

          &:nth-of-type(2) {
            width: 130px;
          }

          &:nth-of-type(3) {
            width: 130px;
          }

          &:nth-of-type(4) {
            width: 130px;
          }

          &:nth-of-type(5) {
            width: 130px;
          }

          &:nth-of-type(6) {
            width: 130px;
          }

          &:nth-of-type(7) {
            width: 130px;
          }
        }

        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;

            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }

            .middle {
              border-bottom: 1px solid #e5e5e5;

              .order {
                .order_left {
                  border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }

                .operating {
                  p {
                    margin-top: 10px;

                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .price_box {
        font-size: 14px;

        .price_item {
          padding: 0 20px;
          min-height: 50px;
          background-color: #f0f6ff;
          border-bottom: 1px solid #fff;

          .vip_order_imgs {
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }

        .pay_table {
          height: 100px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;

              &:last-child {
                border-right: none;
              }
            }

            .td {
              width: 33.33%;
            }
          }
        }

        .contract_img {
          width: 150px;
          height: 150px;
          margin-right: 10px;
        }

        .receipt {
          width: 40%;
          border: 1px solid #e5e5e5;

          .top {
            padding: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .bottom {
            padding: 30px 20px;
          }
        }
      }
    }

    .service_box {
      background-color: #fff;
      padding: 20px;
      font-size: 14px;

      .order_cell {
        .order_cell_title {
          width: 130px;
          text-align: right;
        }

        .pay_table {
          width: calc(100% - 170px);
          margin-left: 20px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              height: 50px;
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              width: 25%;
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;
              // border-bottom: 1px solid #e5e5e5;
              &:last-child {
                border-right: none;
              }
            }
          }
        }

        .img {
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }
      }

      .receipt {
        width: 40%;
        border: 1px solid #e5e5e5;

        .top {
          padding: 20px;
          border-bottom: 1px solid #e5e5e5;
        }

        .bottom {
          padding: 30px 20px;
        }
      }
    }

    .pay_title {
      width: 80px;
    }

    .way {
      padding: 20px 0;
      border-bottom: 1px solid #e5e5e5;

      .el-radio {
        width: 20px;
        height: 20px;

        .el-radio__input {
          width: 100%;
          height: 100%;
        }
      }

      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/payment/index.vue